import { DATA_TESTID, Text_INTERNAL } from "../Text_INTERNAL";
import type { TextInternalProps } from "../Text_INTERNAL";

const styleProps = {
  size: "text-lg md:text-xl",
  leading: "leading-6",
  tracking: "tightest",
};

export interface LabelXlProps extends TextInternalProps {
  "data-testid"?: string;
}

export const LabelXl = ({
  weight = "normal",
  color,
  truncate,
  textAlign = "",
  [DATA_TESTID]: dataTestId,
  children,
}: LabelXlProps) => {
  const props = {
    ...styleProps,
    dataTestId,
    weight: `font-${weight}`,
    color,
    truncate,
    textAlign,
  };

  return (
    <Text_INTERNAL as="span" {...props}>
      {children}
    </Text_INTERNAL>
  );
};
